import { Alert, Typography } from "@mui/material";
import { useGetList, useGetMany, useGetOne } from "react-admin";
import { CreateDrivingLessonForm } from "../AddAppointmentDialog/CreateDrivingLessonForm";
import { DrivingLesson } from "../../model/autovioCalendarEvents";
import { Instructor } from "../../providers/instructorsProvider";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import { Student } from "../../providers/studentsProvider";
import { Vehicle } from "../../providers/vehiclesProvider";
import { useGetDrivingLessonStartingPoint } from "../../hooks/useGetCalendarEventStartingPoint";
import { vehiclesForLicenseClass } from "./vehiclesForLicenseClass";

const _notBilledWarning =
  "Achtung: Hier dokumentierte Termine werden nicht abgerechnet. Für eine Abrechnung bitte den Termin regulär planen.";

export function DocumentHistoricalDrivingLessonForm({
  student,
  onSuccess,
}: {
  student: Student;
  onSuccess: () => void;
}) {
  const { data: drivingLessons = [], isLoading: isLoadingDrivingLessons } = useGetList<DrivingLesson>(
    "studentDrivingLessons",
    {
      filter: { studentUid: student.id, drivingSchoolId: student.drivingSchoolId },
      pagination: { page: 1, perPage: 10 },
      sort: { field: "start", order: "DESC" },
    },
  );
  const lastDrivingLesson = drivingLessons.find(
    (lesson) => lesson.drivingLessonType !== "praktischePruefung" && lesson.drivingLessonType !== "simulator",
  );
  const { data: instructor } = useGetOne<Instructor>(
    "instructors",
    { id: lastDrivingLesson?.instructorId || "" },
    { enabled: !!lastDrivingLesson?.instructorId },
  );
  const bookedTraining = student.bookedTrainings?.find((bt) => bt.id === lastDrivingLesson?.student.bookedTrainingId);
  const { data: vehiclesData = [] } = useGetMany<Vehicle>(
    "vehicles",
    { ids: lastDrivingLesson?.resources ?? [] },
    { enabled: !!lastDrivingLesson?.resources?.length },
  );
  const { startingPoint, isLoading: isLoadingStartingPoint } = useGetDrivingLessonStartingPoint(student);

  if (isLoadingDrivingLessons || isLoadingStartingPoint) {
    return <LoadingIndicator />;
  }

  return (
    <>
      <Alert severity="warning" sx={{ mb: 2, alignItems: "center" }}>
        <Typography variant="body2">{_notBilledWarning}</Typography>
      </Alert>
      <CreateDrivingLessonForm
        isHistoricalLesson
        student={student}
        instructor={instructor}
        drivingLicenseClass={bookedTraining?.drivingLicenseClass}
        vehicles={vehiclesForLicenseClass(vehiclesData, bookedTraining)}
        startingPoint={startingPoint}
        onSuccess={onSuccess}
      />
    </>
  );
}
